import { c as _c } from "react/compiler-runtime";
import { type PostFeedInput } from '@shared/all/validators';
import { localPreferenceActions, type LocalPreferenceState } from '../context/context';
import { useLocalPreferenceState } from '../context/LocalPreferenceContext';
import calculateStartEnd from '../helpers/calculateStartEnd';
import storage from '../helpers/storage';
const useLocalPreference = () => {
  const $ = _c(17);
  const {
    state,
    dispatch
  } = useLocalPreferenceState();
  let t0;
  if ($[0] !== dispatch || $[1] !== state) {
    t0 = updatedSettings => {
      const newLocalPreference = {
        ...state,
        ...updatedSettings
      };
      dispatch({
        type: localPreferenceActions.updatedLocalPreference,
        payload: {
          updatedSettings
        }
      });
      storage.setItem("localPreference", JSON.stringify(newLocalPreference));
    };
    $[0] = dispatch;
    $[1] = state;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const updatedLocalPreference = t0;
  let t1;
  if ($[3] !== dispatch || $[4] !== state) {
    t1 = isMuted => {
      const newLocalPreference_0 = {
        ...state,
        muteVideo: isMuted
      };
      dispatch({
        type: localPreferenceActions.setMuteVideo,
        payload: isMuted
      });
      storage.setItem("localPreference", JSON.stringify(newLocalPreference_0));
    };
    $[3] = dispatch;
    $[4] = state;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const updateMuteVideo = t1;
  let t2;
  if ($[6] !== dispatch || $[7] !== state) {
    t2 = theme => {
      const newLocalPreference_1 = {
        ...state,
        theme
      };
      storage.setItem("localPreference", JSON.stringify(newLocalPreference_1));
      dispatch({
        type: localPreferenceActions.SET_THEME,
        payload: theme
      });
    };
    $[6] = dispatch;
    $[7] = state;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const setTheme = t2;
  let t3;
  if ($[9] !== state) {
    t3 = (params, cursor, strictFactiiiIds) => {
      const isDataMode = state.displayMode === "data" && state.postSortBy;
      const dateRange = isDataMode && cursor ? calculateStartEnd(new Date(cursor), state.postSortBy) : {};
      return {
        ...params,
        cursor: isDataMode ? undefined : cursor,
        type: state.postFilterType ?? undefined,
        filterBots: state.filterBot,
        filterNewAccounts: state.filterNew,
        showBoards: state.showBoards,
        factiiiIds: [...state.selectedFactiiis, ...(params.factiiiIds || [])],
        strictFactiiiIds: strictFactiiiIds ?? [],
        dataFilter: state.dataFilter || undefined,
        ...dateRange
      };
    };
    $[9] = state;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const getPostParams = t3;
  let t4;
  if ($[11] !== getPostParams || $[12] !== setTheme || $[13] !== state || $[14] !== updateMuteVideo || $[15] !== updatedLocalPreference) {
    t4 = {
      localPreferenceState: state,
      updatedLocalPreference,
      updateMuteVideo,
      setTheme,
      getPostParams
    };
    $[11] = getPostParams;
    $[12] = setTheme;
    $[13] = state;
    $[14] = updateMuteVideo;
    $[15] = updatedLocalPreference;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
export default useLocalPreference;